import { Box, Typography } from "@mui/material"
import type { FC } from "react"

import CommentsSection from "@/components/Comment/CommentsSection"
import { CommentParentTableType } from "@/graphql/codegen/graphql"

const AccountingComments: FC<{
  companyId: string
}> = ({ companyId }) => {
  const referenceId = `${companyId}-accounting-comments`
  return (
    <Box className='rounded-[6px] border border-gray-300 bg-white p-6'>
      <Typography className='mb-2 text-ml'>Comments</Typography>
      <CommentsSection type={CommentParentTableType.Company} referenceId={referenceId} />
    </Box>
  )
}

export default AccountingComments
